import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  branchCharacterWarning: {
    id: 'frontbucket.repository.pullRequest.branchCharacterWarning',
    description: 'Warning if branch contains potentially dangerous characters',
    defaultMessage:
      'This branch name may have unintended effects in a Git command',
  },
});
